import React, { useEffect, useState } from "react";
import { FcPaid } from "react-icons/fc";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CnfOrderTable from "./CnF Orders/cnf_order_table";
import { Toast } from "../../CustomComponent/toast";
import Footer from "../../Components/Footer/footer";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import{setCnfOrderPage} from "../../redux/Pagination/pagination"

const CnFOrders = () => {
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    orderType: "",
    sortByDate: "",
  });
  const dispatch = useDispatch();
    const page = useSelector((state) => state.pagination.cnfOrderPage);
  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/cf-orders/all-cf-orders", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.OrdersCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [page, refresh]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPaid className="fs-2  me-1" />
                  CnF Orders
                </h2>
                <h4 className="text-muted m-0 p-0">
                  Manage and track your orders.
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 mb-3">
                <b className="mt-1">
                  <IoIosArrowRoundDown
                    className="fs-2"
                    style={{ color: "green" }}
                  />{" "}
                  Incoming Order
                </b>
                <b className="mt-0">
                  <IoIosArrowRoundUp
                    className="fs-2"
                    style={{ color: "red" }}
                  />{" "}
                  Outgoing Order
                </b>
              </div>
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Order type:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  orderType: e.target.value,
                                })
                              }
                              value={filters.orderType}
                            >
                              <option value="">Select</option>
                              <option value="incoming">Incoming</option>
                              <option value="outgoing">Outgoing</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by date:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                              value={filters.sortByDate}
                            >
                              <option value="">Select</option>
                              <option value="new orders">New orders</option>
                              <option value="old orders">Old orders</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      sortByDate: "",
                                      orderType: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Order type:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                orderType: e.target.value,
                              })
                            }
                            value={filters.orderType}
                          >
                            <option value="">Select</option>
                            <option value="incoming">Incoming</option>
                            <option value="outgoing">Outgoing</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Sort by date:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByDate: e.target.value,
                              })
                            }
                            value={filters.sortByDate}
                          >
                            <option value="">Select</option>
                            <option value="new orders">New orders</option>
                            <option value="old orders">Old orders</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    sortByDate: "",
                                    orderType: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <CnfOrderTable
                  data={data?.OrdersData}
                  currentPage={page}
                  itemsPerPage={50}
                />
                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    {/* <a data-bs-toggle="modal" data-bs-target="#modal-team">
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" /> Create Order
                      </button>
                    </a> */}
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={(newPage) => dispatch(setCnfOrderPage(newPage))}
                  totalPages={totalPages}
                  pageDatalength={data?.OrdersData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CnFOrders;
